import ServiceAccounts from "@affinity/Store/ServiceAccounts";
import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
export interface SetQuantityParameters { 
    quantity: number,
    billToId: string,
}

// Internal parameters
interface Props { 
    quantity: number,
    shipTos: ShipToCollectionModel,
}

type HandlerType = Handler<SetQuantityParameters, Props>;

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/Quantity/Set",
        quantity: props.parameter.quantity
    });
}

export const LoadAddresses: HandlerType = async (props) => {
    if (!props.parameter.billToId)
    {
        return;
    }

    props.shipTos = await new ServiceAccounts().getAddresses(props.parameter.billToId);
}

export const SetAddresses: HandlerType = props => {
    if (props.shipTos) {
        (props.dispatch as customDispatch)({
            type: "Affinity/PlaceOrder/SetAddresses",
            addressCollection: props.shipTos
        });
    }

    (props.dispatch as customDispatch)({
        type: "Affinity/PlaceOrder/SwitchAddressMode",
        value: false
    });
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    UpdateState,
    LoadAddresses,
    SetAddresses,
    Tracking,
];

const setQuantity = createHandlerChainRunner(chain, "PlaceOrderSetQuantity");
export default setQuantity;